"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const register_1 = require("@/api/register");
let Register = class Register extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.read = false;
        this.dialog = false;
        this.customerList = []; // 服务供应商
        this.showOtherCountry = false;
        this.userList = []; // 业务员列表
        this.userDetail = null; // 业务员详情
        this.form = {
            password: '',
            repeatPwd: '',
            companyName: '',
            customersId: '',
            country: '',
            companyAddress: '',
            companyPhoto: [],
            vcode: '',
            salesManCode: '',
            email: '',
            tel: '',
            linkman: ''
        };
        this.baseUrl = process.env.VUE_APP_API_URL + '/code/getCode';
        this.img = require('../../../assets/avatar.png');
        this.fileList = [];
        this.countryList = [];
        this.uploadType = 0;
        this.isShowMap = false;
        this.validateFile2 = (rule, value, callback) => {
            if (!this.form.companyPhoto) {
                callback(new Error('请上传证件'));
            }
            else {
                callback();
            }
        };
        this.rules = {
            companyPhoto: [
                { required: true, validator: this.validateFile2, trigger: 'change' }
            ]
        };
        // 中心轴坐标
        this.centerPoint = { lng: 0, lat: 0 };
        this.markerArr = [
            { id: 0, lng: 121.164, lat: 31.275 }
        ];
    }
    getVCode() {
        this.baseUrl += '?' + new Date().getTime();
    }
    validEmail(email) {
        const reg = /^([\S])+[@]{1}([\S])+[.]{1}(\S)+$/;
        return reg.test(email);
    }
    showMap() {
        this.isShowMap = !this.isShowMap;
    }
    onChange(file, fileList) {
        this.fileList = fileList;
    }
    getUserDetail() {
        this.userList.forEach((v) => {
            if (v.saleCode === this.form.salesManCode) {
                this.userDetail = v;
            }
        });
        this.dialog = true;
    }
    handleRemove(e, fileList) {
        this.fileList = fileList;
    }
    beforeAvatarUpload(file) {
        // 文件大小校验
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
            this.$notify.error('文件大小不能超过 10M !');
        }
        return isLt2M;
    }
    httpRequest(file) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    // 完成一次组件卸载 / 重新加载的方法，重新渲染
    handler({ BMap, map }) {
        this.centerPoint.lng = 121.164;
        this.centerPoint.lat = 31.275;
    }
    // 添加点击函数，点击后修改marker的经纬度
    getPoint(e) {
        // businessList({lat: e.point.lat,lng: e.point.lng}).then((res: any)=>{
        //   console.log(res)
        // })
        // 点击获取point经纬度
        const { lng, lat } = e.point;
        // 获取一个随机不重复的字符串做为id
        const id = new Date().getTime() + parseInt(Math.random() * 10000);
        // 新增一个marker标记
        this.markerArr.push({
            id: id,
            lng: lng,
            lat: lat
        });
    }
    onSubmit(form) {
        // 表单校验
        this.$refs.form.validate((valid) => {
            if (valid) {
                if (!this.read) {
                    this.$notify.error('请先同意用户协议');
                    return;
                }
                // console.log(this.form.email)
                // console.log(this.validEmail(this.form.email))
                if (!this.validEmail(this.form.email)) {
                    this.$notify.error('邮件格式错误');
                    return;
                }
                this.form.companyPhoto = String(this.form.companyPhoto);
                register_1.register(this.form).then(res => {
                    this.$notify.success('注册成功，快去登录吧');
                    this.$router.push('/login');
                });
            }
        });
    }
    reset(form) {
        this.$refs.form.resetFields();
    }
    // 验证码
    mounted() {
        document.querySelector('meta[name="keywords"]').setAttribute('content', 'register,crystal,elevator');
        document.querySelector('meta[name="description"]').setAttribute('content', 'After successful registration, you can view all the website contents.');
        document.title = 'Register - Crystal Elevator';
        // 获取动态码
        // this.getVCode()
        register_1.adminUserList({}).then(res => {
            this.userList = res;
        });
        register_1.countryList({}).then((res) => {
            this.countryList = res;
        });
        // const geolocation = new window.BMapGL.Geolocation()
        // geolocation.getCurrentPosition(function (r: any) {
        //   const mk = new window.BMapGL.Marker(r.point)
        //   map.addOverlay(mk)
        //   map.panTo(r.point)
        //   console.log('您的位置：' + r.point.lng + ',' + r.point.lat)
        // })
        // 百度地图API功能
        const map = new window.BMapGL.Map('map', { restrictCenter: false });
        const point = new window.BMapGL.Point(121.164, 31.275);
        map.centerAndZoom(point, 4); // 初始化地图,设置中心点坐标和地图级别
        map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
        const marker = new window.BMapGL.Marker(point, { enableDragging: true }); // 标记可拖拽
        map.addOverlay(marker); // 标注添加到地图中
        map.panBy(500, 300); // 中心点偏移多少像素（width,height）为地图所在div 宽高的1/2;
        // const scaleCtrl = new BMapGL.ScaleControl() // 添加比例尺控件
        // map.addControl(scaleCtrl)
        //@ts-ignore
        const zoomCtrl = new window.BMapGL.ZoomControl(); // 添加缩放控件
        map.addControl(zoomCtrl);
        //@ts-ignore
        const cityCtrl = new window.BMapGL.CityListControl(); // 添加城市列表控件
        map.addControl(cityCtrl);
        const that = this;
        marker.addEventListener('dragend', function (e) {
            const req = { lat: e.latLng.lat, lng: e.latLng.lng, pageNo: 1, pageSize: 10 };
            register_1.businessList(req).then((res) => {
                that.customerList = res;
            });
        });
    }
};
Register = __decorate([
    vue_property_decorator_1.Component({
        components: { HeaderTop: () => Promise.resolve().then(() => __importStar(require('@/components/HeaderTop/HeaderTop.vue'))), FooterBottom: () => Promise.resolve().then(() => __importStar(require('@/components/FooterBottom/Foot.vue'))) }
    })
], Register);
exports.default = Register;
